import { Image } from "@chakra-ui/react"
import LogoSvg from "./logo.svg"

export const Logo = () => {
  return <Image objectFit="contain" src={LogoSvg} alt="ESG logo" my="8" />
}
